export type Sector =
  | 'mode' | 'cosmetique' | 'parfumerie' | 'maison'
  | 'jardin' | 'electronique' | 'food' | 'autre'
export type Sourcing = 'import' | 'ue' | 'local' | 'mix'
export type Zone = 'be' | 'eu' | 'uk' | 'ch' | 'world'
export type Platform = 'shopify' | 'woocommerce' | 'prestashop' | 'magento' | 'amazon' | 'other'

export const SECTORS: Sector[] = ['mode', 'cosmetique', 'parfumerie', 'maison', 'jardin', 'electronique', 'food', 'autre']
export const SOURCINGS: Sourcing[] = ['import', 'ue', 'local', 'mix']
export const ZONES: Zone[] = ['be', 'eu', 'uk', 'ch', 'world']
export const PLATFORMS: Platform[] = ['shopify', 'woocommerce', 'prestashop', 'magento', 'amazon', 'other']

export type DevisAnswers = {
  sector: Sector | null
  sourcing: Sourcing | null
  avgBasket: number // €
  ordersPerMonth: number
  itemsPerParcel: number
  weightPerItem: number // grams
  homeDeliveryPct: number // 0–100, home delivery share (pickup-point = 100 − this)
  zones: Zone[]
  name: string
  email: string
  phone: string
  website: string
  platform: Platform | ''
}

export const INITIAL_ANSWERS: DevisAnswers = {
  sector: null,
  sourcing: null,
  avgBasket: 35,
  ordersPerMonth: 300,
  itemsPerParcel: 3,
  weightPerItem: 300,
  homeDeliveryPct: 85,
  zones: [],
  name: '',
  email: '',
  phone: '',
  website: '',
  platform: '',
}
